/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-bottom-box[_ngcontent-%COMP%]{padding-bottom:15px!important}.padding-top-box[_ngcontent-%COMP%]{padding-top:15px!important}"];
export { styles as styles };
